/** @format */

//import components
import HeadTitle from "../../components/global/HeadTitle";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";

import Chat from "./chat";

const Support = () => {
  return (
    <NavbarAndSidebar>
      <div className='flex-between'>
        <HeadTitle title='الدعم الفني' margin={true} />
      </div>
      <div className='mb__small' />
      <Chat />
    </NavbarAndSidebar>
  );
};
export default Support;
